export default "__VITE_ASSET__D2zre1WX__"